// Vendors
import styled from 'styled-components';
// Utilities
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const LayoutOperationalAssetComponentStyled = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
LayoutOperationalAssetComponentStyled.displayName = 'LayoutOperationalAssetComponentStyled';

export { LayoutOperationalAssetComponentStyled };
